<template>
    <div class="emn" @mouseenter="hover = true" @mouseleave="hover = false">
        {{resource.value || column.name}}
        <span
            class="emn__edit-trigger"
            v-show="editable && (hover || editing.on)"
            @click="edit"
        >
            <i class="icon icon--action-edit"></i>
        </span>
        
        <span class="emn__editing" v-if="editing.on">
            <span class="emn__editing__container">
                <input
                    v-model="editing.newValue"
                    :disabled="loading"
                    type="text"
                    maxlength="19"
                    class="form__field form__field--short form__field--small"
                >
            </span>
            
            <span v-if="!loading" class="lazy-parameter__editing__buttons">
                <a @click="discard" class="lazy-parameter__editing__button">
                    <i class="icon icon--action-decline"></i>
                    {{$t('buttons.cancel')}}
                </a>
                <a @click="save" class="lazy-parameter__editing__button">
                    <i class="icon icon--action-approve"></i>
                    {{$t('buttons.save')}}
                </a>
            </span>
        </span>
        
        <span class="emn__loading">
            <i
                class="icon icon--common-spinner spinner"
                :class="{'spinner--finished': loading == false}"
            ></i>
        </span>
    </div>
</template>

<script>
import * as api from '@/api';

export default {
    props: {
        id: String,
        node_id: Number,
        function_id: Number,
        column: Object,
    },
    data() {
        return {
            oid: '4/5',
            hover: false,
            resource: false,
            editable: false,
            loading: false,
            editing: {
                on: false,
                newValue: this.column.name,
            },
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            api.systems
                .datapoint({
                    endpoint: 'object',
                    id: this.id,
                    node_id: this.node_id,
                    function_id: this.function_id,
                    oid: this.oid,
                })
                .then(
                    response => {
                        // name editable
                        this.resource = response.data;
                        this.editable = !this.resource.writeProt;
                    },
                    () => {
                        // name not editable
                        this.editable = false;
                    }
                );
        },
        edit() {
            this.editing.on = true;
        },
        discard() {
            this.editing.on = false;
            this.hover = false;
        },
        save() {
            this.loading = true;

            api.systems
                .datapointUpdate({
                    endpoint: 'object',
                    id: this.id,
                    node_id: this.node_id,
                    function_id: this.function_id,
                    oid: this.oid,
                    value: this.getEditValue(),
                })
                .then(
                    response => {
                        this.editing.on = false;
                        this.hover = false;
                        this.loading = false;
                        this.fetchData();
                    },
                    () => {
                        this.loading = false;
                    }
                );
        },
        getEditValue() {
            return {
                OID: `/1/${this.node_id}/${this.function_id}/${this.oid}/0`,
                subtypeId: 9,
                typeId: 30,
                value: this.editing.newValue,
            };
        },
    },
};
</script>

<style lang="scss">
.emn {
    position: relative;
    padding-right: 15px;

    &__edit-trigger {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
    }

    &__editing {
        position: absolute;
        z-index: 10;

        background-color: white;
        border-radius: 3px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
        white-space: nowrap;
        top: 100%;
        right: -18px;
        margin-top: 15px;

        &:before {
            content: '';
            position: absolute;
            z-index: -1;
            width: 10px;
            height: 10px;
            background-color: white;
            transform: rotate(45deg);
            top: -5px;
            right: 20px;
            margin-top: 2px;
            box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.12);
        }

        &__container {
            padding: 10px 12px;
            display: block;

            > input,
            > select {
                width: 100%;
            }

            &--padding-less {
                padding: 0;
            }
        }

        &__buttons {
            display: table;
            width: 100%;
        }

        &__button {
            display: table-cell;
            padding: 10px;

            text-align: center;
            vertical-align: center;
            font-size: 12px;
            cursor: pointer;

            .icon {
                font-size: 16px;
                margin-right: 3px;
            }
        }
    }
}
</style>


